module.exports = __webpack_public_path__ + "img/horizontal_4_4_0.65bf13b6.png";